// extracted by mini-css-extract-plugin
module.exports = {"card":"leftSidebar_card__3BXNP"};